module.exports = "<p>\n  structureformats works!\n</p>\n"